import React, { useState } from 'react';
import { deleteProfileMember, setProfileMemberIsAdmin } from 'services/profiles';
import { BygrProfileDetails, ProfileMember } from 'types';
import { createDataTable } from 'components/DataTable';
import {
    ConfirmButton,
    CustomLink,
    IconToast,
    LoadingIndicator,
    Select,
} from '@ygtechnologies/bygr-frontend-component-library';
// import theme from './ProjectDetails.module.scss';

interface Props {
    profile: BygrProfileDetails;
    reloadProfile(): void;
}
const MemberDataTable = createDataTable<ProfileMember>();

const ProfileMembers: React.FC<Props> = ({ profile, reloadProfile }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [memberTableState, setMemberTableState] = useState(MemberDataTable.getInitialState('userId'));

    const handleSetProfileMemberIsAdmin = async (profileMemberId: number, isAdmin: boolean) => {
        setIsLoading(true);
        await setProfileMemberIsAdmin(profileMemberId, isAdmin as boolean);
        await reloadProfile();
        IconToast.success('Is Admin set to ' + isAdmin);
        setIsLoading(false);
    };

    const handleDeleteProfileMember = async (profileMemberId: number) => {
        try {
            setIsLoading(true);
            await deleteProfileMember(profileMemberId);
            await reloadProfile();
        } catch (e) {
            if ((e as any).status === 400) {
                IconToast.error('Error: Profilemember is connected to a project');
            } else {
                console.log(e);
            }
        } finally {
            setIsLoading(false);
        }
    };

    if (!profile) {
        return <LoadingIndicator />;
    }

    const isAdminArray = [
        { value: true, label: 'Yes' },
        { value: false, label: 'No' },
    ];

    return (
        <>
            <MemberDataTable
                hasPagination={false}
                data={profile.members}
                onStateChange={setMemberTableState}
                state={memberTableState}
                totalItemCount={profile.members.length}
                className="table style-3">
                <MemberDataTable.Column header="User Id" field="userId" renderer={({ value }) => value} />
                <MemberDataTable.Column header="Profile Member Id" field="profileMemberId" renderer={({ value }) => value} />
                <MemberDataTable.Column header="Email" field="email" renderer={({ value }) => value} />
                <MemberDataTable.Column
                    header="User Name"
                    field="userName"
                    renderer={({ value, row }) => <CustomLink to={`/users/${row.userId}`}>{value}</CustomLink>}
                />
                <MemberDataTable.Column
                    header="Is Admin"
                    field="isAdmin"
                    renderer={({ value, row }) => (
                        <Select
                            isDisabled={isLoading}
                            onChange={(v: any) => handleSetProfileMemberIsAdmin(row.profileMemberId, v!.value)}
                            value={isAdminArray.find((x) => x.value === value)}
                            options={isAdminArray}
                        />
                    )}
                />
                <MemberDataTable.Column
                    header="Delete member"
                    field="userId"
                    renderer={({ value, row }) => (
                        <ConfirmButton
                            dialogTitle="Are you sure?"
                            dialogBody="Are you sure, this cannot be reverted."
                            onConfirm={() => handleDeleteProfileMember(row.profileMemberId)}
                            color="danger"
                            loading={isLoading}>
                            Delete profile member
                        </ConfirmButton>
                    )}
                />
            </MemberDataTable>
        </>
    );
};

export default ProfileMembers;
